<template>
  <div class="bookmarks-app__container">
    <span class="section-title">
      {{ SECTION_TITLE }}
    </span>

    <div class="bookmarks__banner-block">
      <span class="bookmarks__banner-block__text">
        {{ BANNER_TEXT }}
      </span>
      <a
        :href="optional_params.download_app_url"
        class="bookmarks__banner-block__button"
      >
        {{ DOWNLOAD_BUTTON }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadApp',
  data() {
    return {
      SECTION_TITLE: 'Bookmarks',
      BANNER_TEXT: 'To use bookmarks download new AD mobile apps!',
      DOWNLOAD_BUTTON: 'Get the app',
    }
  },
}
</script>

<style scoped lang="scss">
.bookmarks-app__container {
  display: none;
}

@media (max-width: 575.98px) {
  .bookmarks-app__container {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .section-title {
      font-family: DM Sans, serif;
      font-size: 18px;
      font-weight: 500;
      line-height: 26px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: #323232;
    }

    .bookmarks__banner-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 156px;
      border-radius: 8px;
      gap: 16px;

      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='903' height='193' viewBox='0 0 903 193' fill='none'%3E%3Cg clip-path='url(%23clip0_17472_340457)'%3E%3Crect width='903' height='193' rx='8' fill='%23F3F4F5'/%3E%3Cpath d='M-263 27.8955L146.226 -93.7939L155.232 -77.9505L-242.163 64.5515L-263 27.8955Z' fill='url(%23paint0_linear_17472_340457)'/%3E%3Cpath d='M1215.33 27.8955L806.103 -93.7939L797.097 -77.9505L1194.49 64.5515L1215.33 27.8955Z' fill='url(%23paint1_linear_17472_340457)'/%3E%3Cpath d='M-134.084 176.02L199.754 -40.8374L215.121 -28.1157L-98.5297 205.453L-134.084 176.02Z' fill='url(%23paint2_linear_17472_340457)'/%3E%3Cpath d='M1033.02 176.02L699.183 -40.8374L683.816 -28.1156L997.466 205.453L1033.02 176.02Z' fill='url(%23paint3_linear_17472_340457)'/%3E%3Cpath d='M28.9531 279.648L269.232 0.507077L288.686 9.45119L73.9627 300.342L28.9531 279.648Z' fill='url(%23paint4_linear_17472_340457)'/%3E%3Cpath d='M862.868 279.648L622.589 0.5071L603.135 9.45122L817.859 300.342L862.868 279.648Z' fill='url(%23paint5_linear_17472_340457)'/%3E%3Cpath d='M218.538 341.563L348.597 23.1355L370.54 27.688L269.307 352.096L218.538 341.563Z' fill='url(%23paint6_linear_17472_340457)'/%3E%3Cpath d='M673.392 341.563L543.333 23.1355L521.389 27.6881L622.622 352.096L673.392 341.563Z' fill='url(%23paint7_linear_17472_340457)'/%3E%3Cpath d='M422.243 371L435.467 36.5545L455.994 36.5545L469.735 371L422.243 371Z' fill='url(%23paint8_linear_17472_340457)'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_17472_340457' x1='160.306' y1='-83.6726' x2='134.381' y2='40.1852' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23E6EDF0'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_17472_340457' x1='792.023' y1='-83.6726' x2='817.948' y2='40.1852' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23E6EDF0'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_17472_340457' x1='217.436' y1='-34.7842' x2='223.614' y2='89.8003' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23DBE7ED'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear_17472_340457' x1='681.501' y1='-34.7842' x2='675.322' y2='89.8003' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23DBE7ED'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint4_linear_17472_340457' x1='288.443' y1='2.55791' x2='322.501' y2='125.788' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23DBE7ED'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint5_linear_17472_340457' x1='603.379' y1='2.55793' x2='569.321' y2='125.788' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23DBE7ED'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint6_linear_17472_340457' x1='367.812' y1='21.1099' x2='432.816' y2='139.305' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23DBE7ED'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint7_linear_17472_340457' x1='524.117' y1='21.11' x2='459.113' y2='139.305' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23DBE7ED'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint8_linear_17472_340457' x1='451.554' y1='30.7332' x2='551.362' y2='125.678' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F3F4F5'/%3E%3Cstop offset='1' stop-color='%23DBE7ED'/%3E%3C/linearGradient%3E%3CclipPath id='clip0_17472_340457'%3E%3Crect width='903' height='193' rx='8' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");

      .bookmarks__banner-block__text {
        max-width: 268px;
        height: 40px;
        font-family: DM Sans, serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #323232;
      }

      .bookmarks__banner-block__button {
        max-width: 311px;
        width: 100%;
        height: 40px;
        top: 84px;
        left: 16px;
        padding: 9px 16px 9px 16px;
        gap: 10px;
        border-radius: 6px;
        font-family: DM Sans, serif;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: #ffffff;
        background: #6998ae;
        justify-content: center;
        display: flex;
      }
    }
  }
}
</style>
